//import './bootstrap';
import './core/eventBus';
import './core/axios';
import store from './store/index';
import __t from "./mixins/translate";
import getObjectPathProperty from "./mixins/getObjectPathProperty";
import G_AUTH from './components/auth/auth_page';
import G_ORDERS_PAGE from "./components/order/orders_page";
import G_HEADING from "./components/heading/heading";
import G_HOME_PAGE from "./components/order/home_page";
import G_MODAL_LEFT from "./components/modal/left/modal_left";
import G_COURIERS_PAGE from "./components/courier/couriers_page";
//import G_MENU_PANEL_PAGE from "./components/menu/panel/menu_panel";
import G_MENU_MAIN_PAGE from "./components/menu/main/menu_main";
import G_SETTING_SYNC_PAGE from "./components/setting/setting_sync_page";
import G_REST_SELECT_PAGE from "./components/rest/select/rest_select_page";
import G_REST_STOP_LIST_PAGE from "./components/rest/stop_list/rest_stop_list_page";
import G_REST_ACTIVE_PAGE from "./components/rest/active/rest_active_page";
import {includeCurrentUrlString} from "./helpers/includeCurrentUrlString";
import {globalMixins} from "./mixins/globalMixins";
import Toast from "vue-toastification";
import {useToast} from "vue-toastification";
import "vue-toastification/dist/index.css"

import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { far } from '@fortawesome/free-regular-svg-icons';
import { fab } from '@fortawesome/free-brands-svg-icons';
library.add(fas, far, fab)


const optionsToast = {
    transition: "Vue-Toastification__bounce",
    maxToasts: 8,
    newestOnTop: true,
    position: "top-right",
    timeout: 5000,
    closeOnClick: true,
    pauseOnFocusLoss: true,
    pauseOnHover: false,
    draggable: true,
    draggablePercent: 0.7,
    showCloseButtonOnHover: false,
    hideProgressBar: true,
    closeButton: "button",
    icon: true,
    rtl: false,
}

window.$store = store;
window.io = require("socket.io-client");

if (!includeCurrentUrlString('login')) {
    store.dispatch('user/LOAD_USER', {actionName: 'loadUser'});
}

//store.dispatch('aggregators/GET_ALL_SELECT_LOCATIONS_ID', {actionName: 'getAllSelectLocationsId'});

if (document.getElementById('go_auth')) {
    G_AUTH.config.globalProperties.$toast = useToast();
    G_AUTH
        .mixin(__t)
        .use(store)
        .use(Toast, optionsToast)
        .mount('#go_auth')
}

if (document.getElementById('go_heading_right')) {
    G_HEADING.config.globalProperties.$toast = useToast();
    G_HEADING
        .mixin(__t)
        .use(store)
        .use(Toast, optionsToast)
        .mount('#go_heading_right');

}

if (document.getElementById('go_home_page')) {
    G_HOME_PAGE.config.globalProperties.$toast = useToast();
    G_HOME_PAGE
        .mixin(__t)
        .use(store)
        .use(Toast, optionsToast)
        .mount('#go_home_page');

}

if (document.getElementById('go_orders_page')) {
    G_ORDERS_PAGE.config.globalProperties.$toast = useToast();
    G_ORDERS_PAGE
        .mixin(getObjectPathProperty)
        .mixin(__t)
        .mixin(globalMixins)
        .use(store)
        .use(Toast, optionsToast)
        .mount('#go_orders_page');
}
if (document.getElementById('go_couriers_page')) {
    G_COURIERS_PAGE.config.globalProperties.$toast = useToast();
    G_COURIERS_PAGE
        .component('font-awesome-icon', FontAwesomeIcon)
        .mixin(getObjectPathProperty)
        .mixin(__t)
        .use(store)
        .use(Toast, optionsToast)
        .mount('#go_couriers_page');
}

// if (document.getElementById('go_menu_panel')) {
//     G_MENU_PANEL_PAGE.config.globalProperties.$toast = useToast();
//     G_MENU_PANEL_PAGE
//         .mixin(__t)
//         .use(store)
//         .use(Toast, optionsToast)
//         .mount('#go_menu_panel');
// }

if (document.getElementById('go_menu_main')) {
    G_MENU_MAIN_PAGE.config.globalProperties.$toast = useToast();
    G_MENU_MAIN_PAGE
        .mixin(__t)
        .use(store)
        .use(Toast, optionsToast)
        .mount('#go_menu_main');
}
if (document.getElementById('go_rest_select_page')) {
    G_REST_SELECT_PAGE.config.globalProperties.$toast = useToast();
    G_REST_SELECT_PAGE
        .mixin(getObjectPathProperty)
        .mixin(__t)
        .use(store)
        .use(Toast, optionsToast)
        .mount('#go_rest_select_page');
}

if (document.getElementById('go_rest_active_page')) {
    G_REST_ACTIVE_PAGE.config.globalProperties.$toast = useToast();
    G_REST_ACTIVE_PAGE
        .mixin(__t)
        .mixin(getObjectPathProperty)
        .use(store)
        .use(Toast, optionsToast)
        .mount('#go_rest_active_page');
}

if (document.getElementById('go_rest_stop_list_page')) {
    G_REST_STOP_LIST_PAGE.config.globalProperties.$toast = useToast();
    G_REST_STOP_LIST_PAGE
        .component('font-awesome-icon', FontAwesomeIcon)
        .mixin(getObjectPathProperty)
        .mixin(__t)
        .use(store)
        .use(Toast, optionsToast)
        .mount('#go_rest_stop_list_page');
}

if (document.getElementById('go_setting_sync_page')) {
    G_SETTING_SYNC_PAGE.config.globalProperties.$toast = useToast();
    G_SETTING_SYNC_PAGE
        .mixin(__t)
        .mixin(getObjectPathProperty)
        .use(store)
        .use(Toast, optionsToast)
        .mount('#go_setting_sync_page');
}

if (document.getElementById('go_modal_left')) {
    G_MODAL_LEFT.config.globalProperties.$toast = useToast();
    G_MODAL_LEFT
        .mixin(__t)
        .use(store)
        .use(Toast, optionsToast)
        .mount('#go_modal_left');
}
